module.exports = __webpack_public_path__ + "img/if_8.eabb0163.png";